	/* Show more posts button - to reveal more posts
	theButton: Pretty much the button you clicked (typically parse "jQuery(this)"). It's for "if you don't need it anymore (all items are visible), remove it"
	elementsToShow: These will be hidden elements.
	theLimit: How many to reveal at a time
	theDisplay: The final display value from the value "none" (inline, block, flex etc...)
	*/
	function show_more(theButton,elementsToShow,theLimit,theDisplay){
		var x = 0;
		jQuery(elementsToShow).each(function(){
			if(jQuery(this).is(':hidden')){
				jQuery(this).slideDown({
					start: function () {
						jQuery(this).css({display: theDisplay});
					},
					done: function(){
						if( jQuery(elementsToShow+':hidden').length < 1 ){
							theButton.remove();
						}
					}
				});
				x++;
			}
			if(x >= theLimit){
				return false;
			}
		});
	}

  
  //Show more News/Events
	jQuery('.more_news a').on('click', function(){
		show_more(jQuery(this),'.grid-item',2,'block');
	});